import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { faqs } from '@/mocks/faqs';

function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20luxurious%20golden%20geometric%20pattern%20with%20warm%20ambient%20lighting%2C%20soft%20gradient%20background%2C%20elegant%20minimalist%20design%2C%20subtle%20texture%2C%20premium%20atmosphere%2C%20dark%20warm%20tones%20with%20golden%20highlights%2C%20no%20text%20no%20people%2C%20clean%20modern%20aesthetic&width=1600&height=900&seq=hero-bg-zygjb&orientation=landscape"
        alt="众赢zygjb官方入口"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
          <i className="ri-shield-check-line text-accent-400 text-sm"></i>
          <span className="text-accent-300 text-xs font-medium tracking-wide">
            官方正版平台 · 安全稳定可靠
          </span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          众赢zygjb官方入口
        </h1>
        <p className="text-base md:text-lg text-background-200/80 max-w-2xl mx-auto leading-relaxed mb-10">
          玩家信赖的正版平台，提供安全稳定的登录通道。汇聚官方最新入口地址，确保您快速访问众赢zygjb平台，享受流畅体验与专业客服保障。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            <i className="ri-login-box-line text-lg"></i>
            立即安全登录
          </a>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/10 text-background-50 font-medium text-sm rounded-full hover:bg-background-50/20 border border-background-50/20 transition-all whitespace-nowrap"
          >
            <i className="ri-information-line text-lg"></i>
            了解更多
          </Link>
        </div>
        <div className="flex items-center justify-center gap-8 mt-12 text-background-200/60 text-xs">
          <div className="flex items-center gap-2">
            <i className="ri-shield-star-line"></i>
            <span>SSL加密传输</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-user-star-line"></i>
            <span>百万玩家信赖</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-customer-service-2-line"></i>
            <span>7×24小时客服</span>
          </div>
        </div>
      </div>
    </section>
  );
}

function FeaturesSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '官方正版认证',
      desc: '众赢zygjb官方入口经过严格认证，确保您访问的是正版平台，杜绝仿冒网站风险，为您的账号安全保驾护航。',
    },
    {
      icon: 'ri-lock-password-line',
      title: '安全加密传输',
      desc: '采用国际领先的SSL加密技术，所有数据传输全程加密，您的个人信息和账号数据得到最严格的保护。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '高速稳定访问',
      desc: '全球多地服务器部署，智能路由优化，确保无论您身在何处都能获得流畅快速的访问体验。',
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择众赢zygjb
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            我们始终将玩家的安全与体验放在首位，以专业技术打造值得信赖的平台入口
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {features.map((f, idx) => (
            <div
              key={idx}
              className="group p-8 rounded-2xl bg-white border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors">
                <i className={`${f.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-base">
                {f.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CategoriesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            内容分类导航
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            按需浏览不同类别的资讯和攻略，快速找到您需要的内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 max-w-6xl mx-auto">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-2xl bg-white border border-background-200/70 hover:border-primary-300 transition-all duration-300 text-center"
            >
              <div className="w-13 h-13 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-500 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 mb-1.5 text-base">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function LatestArticlesSection() {
  const latestArticles = articles.slice(0, 6);
  const thumbnails: Record<string, string> = {
    'article-1': 'https://readdy.ai/api/search-image?query=modern%20gaming%20platform%20announcement%20with%20warm%20golden%20tones%2C%20abstract%20technology%20concept%2C%20clean%20minimalist%20style%2C%20soft%20lighting%2C%20professional%20atmosphere%2C%20no%20text%20no%20people&width=800&height=450&seq=article-thumb-01&orientation=landscape',
    'article-2': 'https://readdy.ai/api/search-image?query=secure%20login%20security%20concept%20with%20warm%20golden%20shield%20icon%2C%20abstract%20technology%20protection%2C%20clean%20minimalist%20style%2C%20soft%20lighting%2C%20professional%20atmosphere%2C%20no%20text%20no%20people&width=800&height=450&seq=article-thumb-02&orientation=landscape',
    'article-3': 'https://readdy.ai/api/search-image?query=gaming%20strategy%20guide%20concept%20with%20warm%20golden%20accents%2C%20abstract%20chess%20pieces%2C%20clean%20minimalist%20style%2C%20soft%20lighting%2C%20professional%20atmosphere%2C%20no%20text%20no%20people&width=800&height=450&seq=article-thumb-03&orientation=landscape',
    'article-4': 'https://readdy.ai/api/search-image?query=cybersecurity%20protection%20shield%20concept%20with%20warm%20amber%20glow%2C%20abstract%20firewall%20visualization%2C%20clean%20minimalist%20style%2C%20soft%20lighting%2C%20professional%20atmosphere%2C%20no%20text%20no%20people&width=800&height=450&seq=article-thumb-04&orientation=landscape',
    'article-5': 'https://readdy.ai/api/search-image?query=futuristic%20platform%20update%20concept%20with%20golden%20geometric%20shapes%2C%20abstract%20digital%20transformation%2C%20clean%20minimalist%20style%2C%20soft%20lighting%2C%20professional%20atmosphere%2C%20no%20text%20no%20people&width=800&height=450&seq=article-thumb-05&orientation=landscape',
    'article-6': 'https://readdy.ai/api/search-image?query=premium%20VIP%20membership%20concept%20with%20golden%20crown%2C%20abstract%20luxury%20design%2C%20clean%20minimalist%20style%2C%20soft%20lighting%2C%20professional%20atmosphere%2C%20no%20text%20no%20people&width=800&height=450&seq=article-thumb-06&orientation=landscape',
  };
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              最新文章
            </h2>
            <p className="text-sm text-foreground-600">关注众赢zygjb平台最新动态与攻略</p>
          </div>
          <Link
            to="/category/platform-news"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-2xl border border-background-200/70 bg-white hover:border-primary-200 transition-all duration-300 overflow-hidden"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={thumbnails[article.id]}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 font-medium">
                    {article.tags[0]}
                  </span>
                  <span className="text-xs text-foreground-500">{article.publishDate}</span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-sm leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.readCount.toLocaleString()} 阅读
                  </span>
                  <span className="flex items-center gap-1 text-primary-500 font-medium">
                    阅读全文
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="flex sm:hidden justify-center mt-8">
          <Link
            to="/category/platform-news"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            快速了解众赢zygjb平台的常见问题，如有更多疑问请联系客服
          </p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.slice(0, 6).map((faq) => (
            <div
              key={faq.id}
              className="rounded-xl border border-background-200/70 bg-white overflow-hidden"
            >
              <button
                onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
                className="w-full flex items-center justify-between p-5 text-left"
              >
                <h3 className="font-medium text-foreground-900 text-sm pr-4">{faq.question}</h3>
                <div
                  className={`w-7 h-7 rounded-full bg-background-100 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${
                    openId === faq.id ? 'rotate-45' : ''
                  }`}
                >
                  <i className="ri-add-line text-foreground-600 text-xs"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === faq.id ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20golden%20abstract%20gradient%20background%20with%20soft%20glowing%20particles%2C%20luxurious%20atmosphere%2C%20elegant%20minimalist%20design%2C%20subtle%20light%20streaks%2C%20premium%20feel%2C%20rich%20warm%20amber%20and%20dark%20tones%2C%20no%20text%20no%20people&width=1600&height=700&seq=cta-bg-zygjb&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-900/90 via-background-900/70 to-background-900/90"></div>
      <div className="relative z-10 text-center px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          准备好开启您的游戏之旅了吗
        </h2>
        <p className="text-sm text-background-300 max-w-lg mx-auto mb-8">
          通过众赢zygjb官方入口安全登录，畅享优质游戏体验。百万玩家的共同选择，期待您的加入！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#"
            className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-login-box-line text-base"></i>
            安全登录入口
          </a>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-7 py-3 border border-background-300/40 text-background-200 font-medium text-sm rounded-full hover:bg-background-50/10 transition-colors whitespace-nowrap"
          >
            <i className="ri-customer-service-2-line text-base"></i>
            联系客服
          </Link>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <SEOHead
        title="官方正版平台安全登录"
        description="众赢zygjb官方入口是玩家信赖的正版平台，提供安全稳定的登录通道。汇聚官方最新入口地址，确保您快速访问众赢zygjb平台，享受流畅体验与专业客服保障。"
        keywords="众赢zygjb官方入口,众赢zygjb登录,众赢zygjb平台,众赢官方入口,zygjb入口,众赢最新入口,众赢安全登录"
        canonicalUrl="https://zylogin.github.io"
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <LatestArticlesSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '众赢zygjb官方入口 - 首页',
            description:
              '众赢zygjb官方入口是玩家信赖的正版平台，提供安全稳定的登录通道。',
            url: 'https://zylogin.github.io',
            isPartOf: {
              '@type': 'WebSite',
              name: '众赢zygjb官方入口',
              url: 'https://zylogin.github.io',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </>
  );
}